import React, { useContext, useEffect, useState } from "react";
import Close from "../../../../../images/Close.svg";
import { Title } from "../../../../../stories/Title/Title";
import { Button } from "../../../../../stories/Button/Button";
import { Label } from "../../../../../stories/Label/Label";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import { TableHeaderProps } from "../../../../../utils/types";

import {
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import NoData from "../../../../../images/NoData.svg";
import {
  CustomModal,
  getModifiedScrollHeight,
} from "../../../../../utils/UtilFunctions";
import { ViewModalStyles } from "../../../../../styles/CustomModalStyles";
import View from "../supplier/view/Index";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GetSuppliers } from "../supplier/queries/queries";
import {
  AtsAcLdgrEdge,
  AtsAcLdgrOrderField,
  GetSuppliersResult,
  GetSuppliersVars,
  LdgrQueryType,
} from "../supplier/queries/types";
import {
  EMPTY_STRING,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  emptyMessage,
} from "../../../../../utils/constants";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import useUrlParams from "../../../../../customHooks/useUrlParams";

import { Operation } from "../../../../../utils/Enum.types";
import MessageModal from "../../../../../customComponents/MessageModal";
import LoadingModal from "../../../../pages/LoadingModal";
import { selectedItemType } from "./Associate";
import { AppContext } from "../../../../../context/context";
import { payloadTypes } from "../../../../../context/reducer";
import { Checkbox } from "@mui/material";
import { AddItemLdgrAssociByItem } from "./queries/mutations";
import {
  AddItemLdgrAssociByItemResult,
  AddItemLdgrAssociByItemVar,
  AtsStckItemLdgrAssoicOrderField,
  ItemLdgrAssoicQueryType,
} from "./queries/types";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { GetItems } from "../items/queries/queries";
import { AtsStckItemOrderField, ItemQueryType } from "../items/queries/types";
import { GetStckItemLdgrAssociDetails } from "./queries/queries";
import useLabels from "../../../../../customHooks/useLabels";

interface Props {
  selectedItem: selectedItemType;
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const Assign = ({ selectedItem, setModalFlag }: Props) => {
  const { Masters_Table } = useAssetTableJson();
  const [viewModal, setViewModal] = useState(false);
  const { itemLabel, ledgerLabel } = useLabels();
  const { customer_id, company_id } = useUrlParams();

  const { dispatch } = useContext(AppContext);
  const { user_details } = useLoggedInUserDetails();

  const [rows, setRows] = useState<GridValidRowModel[]>([]);
  const [suppliers, setSuppliers] = useState<AtsAcLdgrEdge[]>([]);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [message, setMessage] = useState(emptyMessage);
  const [selectedSuppliers, setSelectedSuppliers] = useState<number[]>([]);

  const handleCheckboxChange = (id: number) => {
    setSelectedSuppliers(
      (prevSelected) =>
        prevSelected.includes(id)
          ? prevSelected.filter((itemId) => itemId !== id) // Remove if already selected
          : [...prevSelected, id] // Add if not selected
    );
  };

  const [GetSupplierDetails, { data, loading, fetchMore }] = useLazyQuery<
    GetSuppliersResult,
    GetSuppliersVars
  >(GetSuppliers);

  const [addItemLdgrAssociByItem, { loading: addLoading }] = useMutation<
    AddItemLdgrAssociByItemResult,
    AddItemLdgrAssociByItemVar
  >(AddItemLdgrAssociByItem, {
    onError: (err) => {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    },
  });

  const dynamicHeaders: TableHeaderProps[] =
    Masters_Table.Masters.Association.Assign.map((header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      cellClassName: header.cellClassName,
      renderCell: (params) => {
        if (header.field === "id") {
          return (
            <>
              <Checkbox
                value={params.row}
                checked={selectedSuppliers.includes(params.row.supplierId)}
                onChange={() => handleCheckboxChange(params.row.supplierId)}
              />
            </>
          );
        }

        return params.value;
      },
    }));
  const columns: GridColDef[] = [...dynamicHeaders];

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.ASSIGN_TO_SUPPLIER
    );
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.ASSIGN_TO_SUPPLIER,
      JSON.stringify(newModel)
    );
  };

  const handleClear = () => {
    setSelectedSuppliers([]);
  };

  const handleClose = () => {
    setMessage(emptyMessage);
    setModalFlag(false);
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetSuppliers.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = suppliers.find(
            (sub) => sub.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setSuppliers(updatedNewData);
        setRows(
          updatedNewData.map(({ node }, index) => ({
            id: index + 1,
            supplierId: node.id,
            desc: node.desc,
            gstNo: node.supplier_details.gstNo,
            city: node.supplier_details.city,
            state: node.supplier_details.state,
            proficiency: node.supplier_details.proficiency,
          }))
        );
      } else {
        setSuppliers(newData);
        setRows(
          newData.map(({ node }, index) => ({
            id: index + 1,
            supplierId: node.id,
            desc: node.desc,
            gstNo: node.supplier_details.gstNo,
            city: node.supplier_details.city,
            state: node.supplier_details.state,
            proficiency: node.supplier_details.proficiency,
          }))
        );
      }
      setEndCursor(data.GetSuppliers.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetSuppliers.edges;
              const pageInfo = fetchMoreResult.GetSuppliers.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetSuppliers.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetSuppliers: {
                  edges: [...suppliers, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetSuppliers.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && rows.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rows]);

  useEffect(() => {
    const fetchData = async () => {
      try {
   
        if ( customer_id) {
          GetSupplierDetails({
            variables: {
              after: null,
              customer_id,
              first: ROWS_PER_PAGE,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsAcLdgrOrderField.CREATED_AT,
              },
          
              name: EMPTY_STRING,
              input: {
                query_type: LdgrQueryType.LDGRS_NOT_ASSOIC_ITEM,
                itemID: selectedItem.itemId ? selectedItem.itemId : 0,
                tableLevel: undefined,
              },
            },
          });
        }
      } catch (err) {
        setMessage({
          flag: true,
          message: (err as Error).message,
          operation: Operation.NONE,
        });
      }
    };
    fetchData();
  }, [customer_id, GetSuppliers]);

  const HandleSubmit = async () => {
    try {
      
      if (selectedSuppliers.length) {
        if (customer_id && selectedSuppliers) {
          addItemLdgrAssociByItem({
            variables: {
            
              customer_id,
              user_details,
              itemId: selectedItem.itemId,
              ldgrIds: selectedSuppliers,
            },
            refetchQueries: [
              {
                query: GetItems,
                variables: {
                  after: null,
                  customerID: customer_id ? customer_id : 0,
                  companyID: company_id ? company_id : 0,
                  first: ROWS_PER_PAGE,
                  orderBy: {
                    direction: OrderDirection.ASC,
                    field: AtsStckItemOrderField.DESC,
                  },
               
                  name: EMPTY_STRING,
                  hsnCode: EMPTY_STRING,
                  input: {
                    query_type: ItemQueryType.All,
                    stckCategoryID: 0,
                    stckGroupID: 0,
                    stckManufacturerID: 0,
                    stckUomID: 0,
                    stckSubCategoryID: 0,
                    ldgrID: 0,
                    subsidiaryID: 0,
                  },
                },
              },
              {
                query: GetStckItemLdgrAssociDetails,
                variables: {
                  customer_id,
             
                  input: {
                    queryType: ItemLdgrAssoicQueryType.BY_ITEM_ID,
                    id: selectedItem.itemId,
                    stckCategoryID: 0,
                    stckGroupID: 0,
                    stckManufacturerID: 0,
                    stckUomID: 0,
                    stckSubCategoryID: 0,
                  },
                  name: "",
                  orderBy: {
                    direction: OrderDirection.ASC,
                    field: AtsStckItemLdgrAssoicOrderField.LDGR_STATUS,
                  },
                },
              },
            ],
          }).then(({ data }) => {
            if (data && data.AddItemLdgrAssociByItem) {
              setMessage({
                flag: true,
                message: "Added successfully",
                operation: Operation.CREATE,
              });
              setSelectedSuppliers([]);
            }
          });
        }
      } else {
        setMessage({
          flag: true,
          message: `${ledgerLabel} is missing`,
          operation: Operation.NONE,
        });
      }
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    }
  };

  return (
    <>
      <div className="assign-supplier">
        <div className="assign-supplier__title">
          <Title>
            Associate {ledgerLabel} to {itemLabel}
          </Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        <div className="assign-supplier__header">
          <div className="assign-supplier__header--grid">
            <Label>{itemLabel} Description</Label>
            <span>:</span>
            <b>{selectedItem.itemDesc}</b>
            <Label>{itemLabel} Code</Label>
            <span>:</span>
            <span>{selectedItem.itemCode}</span>
          </div>
        </div>
        <Title variant="subtitle1">Assign {ledgerLabel}</Title>
        <div className="assign-supplier__tableblock">
          {rows.length ? (
            <StyledDatagrid
              columns={columns}
              rows={rows}
              rowHeight={TABLE_ROW_HEIGHT}
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={handleColumnVisibilityChange}
              initialState={{
                columns: {
                  columnVisibilityModel: columnVisibilityModel,
                },
              }}
              onCellClick={(params) => {
                if (params.field === "desc") {
                  dispatch({
                    type: payloadTypes.SET_SUPPLIER_ID,
                    payload: {
                      supplierId: params.row.supplier_id,
                    },
                  });
                  setViewModal(!viewModal);
                }
              }}
              disableRowSelectionOnClick
              hideFooter
            />
          ) : (
            <>
              <img src={NoData} alt="" className="nodata-image" />
            </>
          )}
        </div>
        <div className="row g-0">
          <div className="col">
            <Button mode="save" onClick={HandleSubmit} />
            <Button mode="clear" onClick={handleClear} />
            <Button mode="cancel" onClick={() => setModalFlag(false)} />
          </div>
          <div className="col-4 flex-end">
            <div className="overall-total-count">
              Selected {ledgerLabel} <b>{selectedSuppliers.length}</b>
            </div>
          </div>
        </div>
      </div>
      <CustomModal
        isOpen={viewModal}
        onRequestClose={() => setViewModal(!viewModal)}
        contentComponent={<View setModalFlag={setViewModal} />}
        style={ViewModalStyles}
      />

      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal flag={loading || addLoading} />
    </>
  );
};

export default Assign;
